import { lazy, Suspense } from "react";

import { createFileRoute } from "@tanstack/react-router";

import LoadingLayover from "@/components/Loading/LoadingLayover";

const EmbedPDF = lazy(() => import("@/components/EmbedPDF"));

const PDF = new URL(`/src/assets/documents/privacy.pdf`, import.meta.url).href;

export const Route = createFileRoute("/privacy")({
  component: () => (
    <Suspense fallback={<LoadingLayover />}>
      <EmbedPDF file={PDF} />
    </Suspense>
  ),
});
